import { API_BASE_URL, FAILURE, POST, GET, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionExcelImportarProveedorEquipo(obj) {
    try {
        let data = { error: true };
        const { code } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-proveedor-equipo/create-configuracion-importar-excel-proveedor-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionExcelImportarProveedorEquipo err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionExcelImportarProveedorEquipo() {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-proveedor-equipo/obtener-configuracion-importar-excel-proveedor-equipo",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionExcelImportarProveedorEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionExcelImportarProveedorEquipo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-proveedor-equipo/actualizar-configuracion-importar-excel-proveedor-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionExcelImportarProveedorEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function guardarImportarExcelProveedorEquipo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-proveedor-equipo/guardar-importar-excel-proveedor-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImportarExcelProveedorEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}
